import { Size } from '~/types/ThemeTypes'
import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const modalStyleParts = [
  'dialog',
  'header',
  'headerText',
  'footer',
  'dialogContainer',
  'body',
  'closeButton',
  'modalOverlay',
] as const

export type MangoModalSizes = Size.sm | Size.md | Size.lg | Size.xl

const helpers = createMultiStyleConfigHelpers(modalStyleParts)

export const MangoModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    dialogContainer: {
      color: 'fg.default',
      ...textStyles[textStyleKeys.Body2],
      alignSelf: 'stretch',
    },
    modalOverlay: {
      backgroundColor: 'overlay.default',
    },
    dialog: {
      backgroundColor: 'bg.panel',
      borderRadius: '0.5rem',
      alignSelf: 'center',
      width: '100%',
    },
    header: {
      display: 'flex',

      justifyContent: 'space-between',
      alignItems: 'center',
      height: '3.75rem',

      paddingX: '1rem',
      paddingY: '0.75rem',
      borderBottom: '2px solid',
      borderBottomColor: 'border.muted',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body1_Bold],
      color: 'fg.default',
      userSelect: 'none',
    },
    footer: {
      display: 'flex',
      height: '3.75rem',
      paddingX: '1rem',
      gap: '0.625rem',
      flexShrink: 0,
      paddingY: 0,
      borderTop: '2px solid',
      borderTopColor: 'border.muted',
    },
    body: {
      padding: '1.25rem',
    },
    closeButton: {},
  },
  sizes: {
    [Size.sm]: {
      dialog: {
        maxWidth: '25rem',
      },
    },
    [Size.md]: {
      dialog: {
        maxWidth: '32rem',
      },
    },
    [Size.lg]: {
      dialog: {
        maxWidth: '42rem',
        maxHeight: '44rem',
      },
    },
    [Size.xl]: {
      dialog: {
        maxWidth: '50rem',
        maxHeight: '42rem',
      },
    },
  },
  defaultProps: {
    size: Size.md,
  },
})

export const useMangoModalStyles = (props?: StyleThemingProps) =>
  mergeMultiStyleConfig(MangoModalStyle, props) as MultiStyleType<
    typeof modalStyleParts
  >
